import { Injectable } from "@angular/core";

import { environment } from '../environments/environment';

@Injectable()
export class Global {
  debug = true;
  nomeSistema = "Top Bridge";
  dominio_site = "https://api-v2.123.com.br";

  dominio_site_painel = window.location.protocol + "//" + window.location.host;
  //dominio_site_painel = "https://painel.onlineresults.com.br";
  copyright = "&copy; " + (new Date().getFullYear()) + " " + this.nomeSistema + " - Sistema Administrativo";
  logoLoginUrl = "/img/sistema/logo_painel.jpg";

  constructor() {
    this.carregarConfiguracaoLocal();
    if (environment.production) {
      this.dominio_site_painel = window.location.protocol + "//" + window.location.host;
    }
  }

  setNomeSistema(nome: string) {
    if (nome) {
      this.nomeSistema = nome;
      this.copyright = "&copy; " + (new Date().getFullYear()) + " " + nome + " - Sistema Administrativo";
    }
  }

  carregarConfiguracaoLocal() {
    try {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', '/config/config.json', false);
      xhr.send(null);
      if (xhr.status === 200) {
        const config = JSON.parse(xhr.responseText);
        if (config && config.apiUrl) {
          this.dominio_site = config.apiUrl;
        }
        if (config && config.logoLoginUrl) {
          this.logoLoginUrl = config.logoLoginUrl;
        }
      }
    } catch (e) {
      // Mantém o padrão caso o arquivo não exista ou ocorra erro
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/global.ts